<template>
  <v-checkbox
    v-bind="$attrs"
    :data-cy="dataCy ? dataCy : false"
    v-on="$listeners">
    <template #message="{ message }">
      {{ $t(message) }}
    </template>
  </v-checkbox>
</template>

<script>
export default {
  name: 'CCheckbox',
  inheritAttrs: false,
  props: {
    dataCy: {
      type: [String, Boolean],
      default: '',
    },
  },
};
</script>
